import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Send, CheckCircle2 } from "lucide-react";

export default function Embed() {
  const [form, setForm] = useState({ customer_name: "", customer_company: "", customer_email: "", customer_phone: "", message: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(null);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.customer_name.trim() || !form.message.trim()) { setError("Nama dan detail kebutuhan wajib diisi."); return; }
    setSending(true);
    try {
      const { data } = await api.post("/public/quote-request", form);
      setDone(data.reference);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setSending(false); }
  };

  return (
    <div className="min-h-screen bg-white p-4 sm:p-6">
      <div className="max-w-lg mx-auto">
        <div className="flex items-center gap-2 mb-4">
          <img src="/grcom-logo.png" alt="CV GRcom" className="h-7 w-auto" />
          <span className="overline text-accent">Minta Penawaran</span>
        </div>
        {done ? (
          <div className="border border-emerald-500/40 bg-emerald-500/5 rounded-sm p-6 text-center" data-testid="embed-success">
            <CheckCircle2 className="w-8 h-8 text-emerald-600 mx-auto mb-3" />
            <h2 className="font-heading font-bold text-lg mb-1">Permintaan Terkirim!</h2>
            <p className="text-muted-foreground text-sm">Ref: <span className="font-mono text-foreground">{done}</span></p>
            <Button className="mt-4 rounded-sm" onClick={() => { setDone(null); setForm({ customer_name: "", customer_company: "", customer_email: "", customer_phone: "", message: "" }); }}>
              Kirim Lagi
            </Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3" data-testid="embed-form">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <Input data-testid="embed-name" placeholder="Nama Anda *" value={form.customer_name} onChange={(e) => setForm({ ...form, customer_name: e.target.value })} className="rounded-sm bg-secondary" required />
              <Input data-testid="embed-company" placeholder="Perusahaan" value={form.customer_company} onChange={(e) => setForm({ ...form, customer_company: e.target.value })} className="rounded-sm bg-secondary" />
              <Input data-testid="embed-email" type="email" placeholder="Email" value={form.customer_email} onChange={(e) => setForm({ ...form, customer_email: e.target.value })} className="rounded-sm bg-secondary" />
              <Input data-testid="embed-phone" placeholder="Telepon / WhatsApp" value={form.customer_phone} onChange={(e) => setForm({ ...form, customer_phone: e.target.value })} className="rounded-sm bg-secondary" />
            </div>
            <Textarea data-testid="embed-message" placeholder="Detail kebutuhan (mis. 10 unit laptop Lenovo E14 Gen 5) *" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="rounded-sm bg-secondary min-h-[90px]" required />
            {error && <div className="text-sm text-destructive font-mono" data-testid="embed-error">{error}</div>}
            <Button data-testid="embed-submit" type="submit" disabled={sending} className="rounded-sm w-full">
              <Send className="w-4 h-4 mr-2" /> {sending ? "Mengirim…" : "Kirim Permintaan"}
            </Button>
            <p className="text-xs text-muted-foreground text-center">Dilayani oleh CV GRcom · IT Support & Infrastruktur</p>
          </form>
        )}
      </div>
    </div>
  );
}
